import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20ink%20wash%20painting%20panoramic%20landscape%2C%20misty%20mountains%20with%20flowing%20waterfall%2C%20traditional%20elegant%20composition%2C%20soft%20teal%20green%20and%20warm%20sepia%20tones%2C%20atmospheric%20depth%2C%20ethereal%20clouds%2C%20horizontal%20scroll%20style%2C%20minimalist%20yet%20grand%2C%20silhouette%20of%20pine%20trees%20in%20foreground%2C%20subtle%20golden%20light%20breaking%20through%20mist&width=1920&height=1080&seq=hero-bg-main-2026&orientation=landscape"
          alt="古风漫画网 - 免费韩国漫画在线阅读"
          title="古风漫画网 - 免费韩国漫画在线阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/25 to-foreground-950/40" />

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center">
        <div className="px-4 md:px-6 w-full max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <div className="animate-fade-in">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-wide font-heading">
                免费韩漫
              </h1>
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-wide font-heading mt-1">
                下拉畅读
              </h2>
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-wide font-heading mt-1">
                古风新韵
              </h2>
            </div>

            <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 animate-slide-up" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed">
                汇聚海量优质韩国漫画资源，以独特古风视角甄选精品佳作。流畅下拉式阅读，为您带来沉浸式漫画体验。
              </p>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed md:mt-4">
                每日更新，画质高清，无需下载即可畅享。让每一页漫画都如诗如画，古韵悠长。
              </p>
            </div>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4 animate-slide-up" style={{ animationDelay: '0.5s', animationFillMode: 'both' }}>
              <Link
                to="/category/all"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-accent-500 text-background-50 rounded-full text-base font-medium hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category/all?sort=rank"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-full text-base font-medium hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                热门排行
                <i className="ri-fire-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-pulse-soft">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center pt-1.5">
          <div className="w-1.5 h-3 bg-background-50/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}